import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Plus, Trash2 } from "lucide-react";

const ROLES = ["super_admin", "editor", "author", "seo_manager", "lead_manager", "viewer"];

export default function AdminUsersPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ email: "", name: "", password: "", role: "author" });

  const load = async () => { const { data } = await api.get("/admin/users"); setItems(data || []); };
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) return;
    try {
      await api.post("/admin/users", form);
      setForm({ email: "", name: "", password: "", role: "author" });
      load();
    } catch (err) { alert(err.response?.data?.detail || err.message); }
  };
  const del = async (id) => { if (!window.confirm("Silinsin mi?")) return; await api.delete(`/admin/users/${id}`); load(); };

  return (
    <div data-testid="admin-users">
      <h1 className="font-serif text-4xl text-cc-text mb-2">Kullanıcılar</h1>
      <p className="text-sm text-cc-muted mb-8">Yönetici hesapları ve roller</p>

      <form onSubmit={add} className="bg-white border border-admin-border p-5 mb-8 grid md:grid-cols-5 gap-3 items-end">
        <label className="text-xs text-cc-muted">E-posta <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="cc-input" /></label>
        <label className="text-xs text-cc-muted">Ad <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="cc-input" /></label>
        <label className="text-xs text-cc-muted">Parola <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="cc-input" /></label>
        <label className="text-xs text-cc-muted">Rol
          <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="cc-input">
            {ROLES.map((r) => <option key={r} value={r}>{r}</option>)}
          </select>
        </label>
        <button className="cc-btn text-[10px] py-2"><Plus size={14} /> Ekle</button>
      </form>

      <div className="bg-white border border-admin-border">
        <table className="w-full text-sm">
          <thead className="bg-admin-bg/60 text-left">
            <tr><th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">E-posta</th>
                <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Ad</th>
                <th className="px-4 py-3 text-[10px] uppercase tracking-overline text-cc-muted">Rol</th>
                <th></th></tr>
          </thead>
          <tbody>
            {items.map((u) => (
              <tr key={u.id} className="border-t border-admin-border">
                <td className="px-4 py-3">{u.email}</td>
                <td className="px-4 py-3 text-cc-muted">{u.name}</td>
                <td className="px-4 py-3"><span className="text-[10px] uppercase tracking-overline text-cc-sepia">{u.role}</span></td>
                <td className="px-4 py-3 text-right">
                  {u.role !== "super_admin" && <button onClick={() => del(u.id)} className="text-cc-muted hover:text-red-600"><Trash2 size={14} /></button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
